import React from "react";
import TableComponent from "../TableComponent";
import LookupComponent from "./LookupComponent";

class LookupComponentContainer extends TableComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      show: false,
      selected: props.selected,
      currentlySelected: this._getCurrentlySelected(this.props.selected)
    };

    this.placeholder = props.placeholder;
    this.identifier = this.props.identifier || "id";
  }

  _getCurrentlySelected = selected => {
    if (selected && Array.isArray(selected)) {
      return [...selected];
    } else {
      return selected;
    }
  };

  initialSortInfo() {
    return {
      orderBy: "name",
      direction: "asc"
    };
  }

  componentDidUpdate() {
    super.componentDidUpdate();

    if (this.state.selected !== this.props.selected) {
      this.setState({
        selected: this.props.selected,
        currentlySelected: this._getCurrentlySelected(this.props.selected)
      });
    }
  }

  lookupTitle() {
    return this.props.title;
  }

  setNode = n => {
    this.node = n;
  };

  columnsHaveFilter = () => {
    var haveFilter = false;
    this.columns.forEach(column => {
      if (column.hasOwnProperty("filter")) {
        haveFilter = true;
      }
    });
    return haveFilter;
  };

  getNonSelectableRows = () => {
    return [];
  };

  getRowEntitySelector = () => {
    return undefined;
  };

  createSelectRow = () => {
    if (this.props.multiple) {
      var selectRow = {
        mode: "checkbox",
        clickToSelect: true,
        selectColumnStyle: {
          textAlign: "center"
        },
        nonSelectable: this.getNonSelectableRows(),
        entitySelector: this.getRowEntitySelector(),
        selected:
          this.state.currentlySelected &&
          Array.isArray(this.state.currentlySelected)
            ? this.state.currentlySelected.map(cs => cs[this.identifier])
            : undefined,
        onSelect: this.onSelectOne,
        onSelectAll: this.onSelectAll
      };

      if (this.columnsHaveFilter()) {
        selectRow.selectionHeaderRenderer = () => (
          <th class="sortable column-header-filtered">
            <div class="table-filter">
              <label class="filter-label">
                <input type="checkbox" />
              </label>
            </div>
          </th>
        );
      } else {
        selectRow.headerColumnStyle = {
          textAlign: "center"
        };
      }
      return selectRow;
    }
  };

  onSelectOne = (row, isSelect) => {
    this.onSelectAll(isSelect, [row]);
  };

  onSelectAll = (isSelect, rows) => {
    let currentlySelected = this.state.currentlySelected;

    rows.forEach(row => {
      const alreadySelected =
        currentlySelected &&
        currentlySelected.find(
          cs => cs[this.identifier] === row[this.identifier]
        );

      if (isSelect && !alreadySelected) {
        currentlySelected = currentlySelected ? currentlySelected : [];
        currentlySelected.push(row);
      } else if (!isSelect && alreadySelected) {
        currentlySelected = currentlySelected.filter(
          cs => cs[this.identifier] !== row[this.identifier]
        );
      }
    });

    this.setState({ currentlySelected: currentlySelected });
  };

  handleOnSelect = () => {
    const selected = this.state.currentlySelected;

    this.onChange(selected);
    this.setState({
      selected: selected,
      currentlySelected: this._getCurrentlySelected(selected),
      show: false
    });
  };

  renderProps() {
    return {
      ...super.renderProps(),
      node: this.setNode,
      selectRow: this.createSelectRow(),
      onRowClick: !this.props.multiple && this.onRowClick,
      show: this.state.show,
      setShow: show => this.setState({ show: show }),
      columns: this.lookupColumnOptions(this.columns)
    };
  }

  lookupColumnOptions = columns => {
    return columns.map(column => {
      return {
        ...column,
        formatExtraData: {
          ...column.formatExtraData,
          overlayClassName: "popover-modal"
        }
      };
    });
  };

  onRowClick = (_, row) => {
    this.onChange(row);
    this.setState({ selected: row, show: false });
  };

  onChange = selected => {
    if (this.props.onChange) {
      let event = selected;

      if (this.props.controlId) {
        event = { target: { id: this.props.controlId, value: selected } };
      }

      this.props.onChange(event);
    }
  };

  handleOnClear = () => {
    this.onChange(undefined);
    this.setState({
      selected: undefined,
      currentlySelected: undefined,
      show: false
    });
  };

  handleOnRemove = deselected => {
    const selectedOld = this.state.selected;
    let selectedNew = undefined;

    if (selectedOld && Array.isArray(selectedOld) && this.props.multiple) {
      selectedNew = selectedOld.filter(
        s => s[this.identifier] !== deselected[this.identifier]
      );
    } else {
      selectedNew = undefined;
    }

    this.onChange(selectedNew);
    this.setState({
      selected: selectedNew,
      currentlySelected: this._getCurrentlySelected(selectedNew),
      show: false
    });
  };

  render() {
    return (
      <LookupComponent
        {...this.renderProps()}
        title={this.lookupTitle()}
        selected={this.state.selected}
        onSelect={this.handleOnSelect}
        multiple={this.props.multiple}
        placeholder={this.placeholder}
        disabled={this.props.disabled || this.props.readOnly}
        required={this.props.required}
        style={this.props.style}
        onClear={this.handleOnClear}
        onRemove={this.handleOnRemove}
        textRenderer={this.props.textRenderer}
      />
    );
  }
}

LookupComponentContainer.defaultProps = {
  dontLoadAfterMount: true
};

export default LookupComponentContainer;
